export default __webpack_public_path__ + "static/media/loader.2b81fe49.svg";